import { Icons } from '@/app/components/ui/Icons'
import classNames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface FullScreenDrawerProps {
	isOpen: boolean
	headerText?: string
	children: React.ReactNode
	overflowHidden?: boolean
	onClose: () => void
	// hashId: string
}

const FullScreenDrawer: React.FC<FullScreenDrawerProps> = ({
	isOpen,
	onClose,
	headerText,
	children,
	overflowHidden
	// hashId,
}) => {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
		return () => setMounted(false)
	}, [])

	// useEffect(() => {
	// 	const handleHashChange = () => {
	// 		if (isOpen && !window.location.hash) {
	// 			onClose()
	// 		}
	// 	}

	// 	if (isOpen) {
	// 		document.body.style.overflow = 'hidden'
	// 		window.location.hash = hashId
	// 		window.addEventListener('hashchange', handleHashChange)
	// 	} else {
	// 		document.body.style.overflow = 'initial'
	// 		if (window.location.hash === `#${hashId}`) {
	// 			window.history.back()
	// 		}
	// 	}

	// 	return () => {
	// 		document.body.style.overflow = 'initial'
	// 		window.removeEventListener('hashchange', handleHashChange)
	// 	}
	// }, [isOpen, onClose, hashId])

	if (!mounted) return null

	const drawer = (
		<AnimatePresence>
			{isOpen && (
				<motion.div
					className={classNames('fixed inset-0 z-[110] bg-white')}
					initial={{ y: '100%' }}
					animate={{ y: 0 }}
					exit={{ y: '100%' }}
					transition={{ type: 'spring', stiffness: 300, damping: 30 }}
					style={{
						top: 0,
						right: 0,
						bottom: 0,
						left: 0,
					}}
				>
					<div className="flex flex-col h-full">
						<motion.div
							className="flex items-center justify-start p-4 border-b border-text-200"
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ delay: 0.2 }}
						>
							<button onClick={onClose} className="p-2 -ms-2">
								<Icons.iconClose />
							</button>
							<h2 className="text-xl font-bold">{headerText}</h2>
						</motion.div>
						<motion.div
							className={classNames("flex-grow overflow-y-auto flex flex-col", {'overflow-y-hidden': overflowHidden})}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ delay: 0.3 }}
						>
							{children}
						</motion.div>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	)

	return createPortal(drawer, document.body)
}

export default FullScreenDrawer
